import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiButton from "Components/MuiButton/MuiButton";
import ImageUpload from "Components/ImageUpload/ImageUpload";
import { read } from "Helpers/LocalStorage";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';

export default function ProfileInfo({ data }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [AvatarUrl, setAvatarUrl] = useState("");
  const [controls, setControls] = useSetState({
    last_Name: {
      type: "text",
      value: "",
      validation: null,
      disabled: false,
    },
  });

  const setValue = (name, value) => {
    setControls({ [name]: { value: value } });
  };

  const onSubmit = () => {
    (async () => {
      try {
        setLoading(true);
        const data = {
          Key: read("userKey"),
          UserName: read("userId"),
          DisplayName: controls.last_Name.value,
          Avatar: AvatarUrl,
        };
        const response = await UserProfileService.putProfileEdit(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          showNotify({
            text: t('mission_accomplished'),
            customClass: "success",
          });
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  };

  useEffect(() => {
    if (data) {
      setControls({ last_Name: { value: data.DisplayName } });
    }
  }, [data]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="d-flex flex-row mb-3" style={{maxWidth: '150px'}}>
        <ImageUpload
          object={'Profile'}
          box_title={'CheckLogo'}
          button_label={'uploadLogo'}
          image={data?.Avatar}
          onSetImage={(url) => setAvatarUrl(url)}
          maxSize={100000}
        />
      </div>
        <Grid container spacing={2}>
          <Grid item sm={4} xs={12}>
            <Input
              setValue={setValue.bind(this)}
              name={'last_Name'}
              validation={controls.last_Name.validation}
              label={<Translator id={'last_Name'} />}
              value={controls.last_Name.value}
              disabled={controls.last_Name.disabled}
              type="text"
            />
          </Grid>
          <Grid item sm={6} xs={12} className="d-flex flex-row justify-content-start align-items-center">
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="zakhire" />}
              onClick={onSubmit}
              fullwidthOnSm
            />
          </Grid>
        </Grid>
    </>
  );
}
